import { createSelector } from '@reduxjs/toolkit';

import { selectBusinessDetails, selectIsPropertyOwner } from './selectBusinessDetails';

export const selectPropertyOwnerOccupation = createSelector(
  selectIsPropertyOwner,
  selectBusinessDetails,
  (isPropertyOwner, businessDetails) => {
    if (businessDetails.propertyOwnerOccupation) return businessDetails.propertyOwnerOccupation;
    if (isPropertyOwner && businessDetails.occupationsList && businessDetails.occupation) {
      const { occupation } = businessDetails;
      const occupationItem = businessDetails.occupationsList.find(
        (o) => o.code === occupation.propertyOwnerAnzsic
      );
      if (occupationItem) {
        return occupationItem;
      }
    }
    return undefined;
  }
);
